/**
 * Shared pan/zoom coordinate-transform math for the app's SVG canvases (OST
 * Canvas.tsx and the Plan page's TimelineCanvas.tsx). Both canvases keep
 * their own pan/zoom state and animation strategy (Canvas.tsx eases toward a
 * fit-to-view target once per load; TimelineCanvas continuously lerps toward
 * a wheel-driven target) — this module only factors out the pure
 * screen-space/canvas-space conversion formula so it can't drift between them.
 */

/** Converts a screen point (e.g. e.clientX/clientY) to canvas space given the SVG's bounds and current pan/zoom. */
export function screenToCanvasPoint(
    bounds: Pick<DOMRect, 'left' | 'top'>,
    pan: { x: number; y: number },
    zoom: number,
    clientX: number,
    clientY: number,
): { x: number; y: number } {
    return {
        x: (clientX - bounds.left - pan.x) / zoom,
        y: (clientY - bounds.top - pan.y) / zoom,
    };
}
